export default "/institutions/revolut.svg";